module.exports = __webpack_public_path__ + "static/media/Bb-blues-scale.12b33456.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/Bb-blues-scale.m4a
// module id = 349
// module chunks = 0